import React from "react";
import styles from "./MessagePickerWidget.css";
import classNames from "classnames";
import { observer } from "mobx-react";

export interface MessageWithCallback {
  message: string;
  callback: () => void;
  disabled?: boolean;
  primary?: boolean;
}

export interface Props {
  messages: MessageWithCallback[];
}

export const WidgetButton = observer(
  ({ message, callback, disabled, primary }: MessageWithCallback) => {
    return (
      <button
        key={message}
        onClick={callback}
        className={classNames(styles["message-picker-button"], { [styles.primary]: !!primary })}
        disabled={disabled}
      >
        {message}
      </button>
    );
  }
);

export const MessagePickerWidget = observer(({ messages }: Props) => {
  const renderMessages = () => {
    const buttons = messages.map((messageWithCallback, index) => (
      <WidgetButton {...messageWithCallback} key={index} />
    ));
    return buttons;
  };

  return <div className={classNames(styles["message-picker-container"])}>{renderMessages()}</div>;
});
